/**
 * "Price to Quote" for quote-only product cards (snippets/quote-button.liquid).
 *
 * The button is rendered disabled and enabled here once the SA Request a Quote (Samita) app has
 * loaded. Clicking it hands the product to the app, which adds it to the quote and, with
 * "after add to quote" set to the popup form, opens its "Products selection" popup.
 * The app only loads data for products on its quote list, so the card's own product JSON is
 * added to GRFQConfigs.products first.
 */
(function () {
  if (window.udAddToQuote) return;

  const BUTTON = '.ud-quote__btn';
  const POLL_MS = 250;
  const POLL_LIMIT = 80; // ~20s

  function appReady() {
    return !!(window.GRFQApp && typeof window.GRFQApp.addProduct === 'function' && window.GRFQConfigs);
  }

  function enable(root) {
    root.querySelectorAll(`${BUTTON}.is-disabled`).forEach((button) => {
      button.classList.remove('is-disabled');
      button.removeAttribute('aria-disabled');
    });
  }

  function readProduct(button) {
    const wrapper = button.closest('.ud-quote');
    const script = wrapper && wrapper.querySelector('.ud-quote__product');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  window.udAddToQuote = function (button) {
    if (button.getAttribute('aria-disabled') === 'true' || !appReady()) return;

    const productId = button.dataset.productId;
    const configs = window.GRFQConfigs;
    if (!Array.isArray(configs.products)) configs.products = [];
    const known = configs.products.some((p) => p && String(p.id) === String(productId));
    if (!known) {
      const product = readProduct(button);
      if (product) configs.products.push(product);
    }

    window.GRFQApp.addProduct(button, productId);
  };

  function onReady() {
    enable(document);
    // Cards re-rendered later (filters, sorting, pagination, sliders) arrive disabled too.
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) enable(node.matches(BUTTON) ? node.parentNode : node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    if (appReady()) return onReady();
    let tries = 0;
    const timer = setInterval(() => {
      if (appReady()) {
        clearInterval(timer);
        onReady();
      } else if (++tries >= POLL_LIMIT) {
        clearInterval(timer);
      }
    }, POLL_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
